import { useReducer } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { FieldCacheService, NSARouterMaker, NSARouterMakerResult, NSFRouterMaker } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { EnvService, IStorageSession } from 'namirasoft-core';
import { NSNotFoundPage } from "namirasoft-site-react";
import { NamirasoftNWSRegionServer } from "namirasoft-nws-region";
// Layout & Routes
import { NWSRegionLayout } from "./NWSRegionLayout";
import { NWSRegionRoutes } from "./NWSRegionRoutes";
// Pages
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import RegionListPage from "./pages/RegionListPage";
import RegionViewPage from "./pages/RegionViewPage";

export default function Router()
{
    let [, page_force_update] = useReducer((x) => x + 1, 0);

    let navigate = useNavigate();

    return <NSARouterMaker
        product_id={ProductUUID.NAMIRASOFT_NWS_REGION}
        notifier_storage={new IStorageSession()}
        page_force_update={page_force_update}
        navigate={navigate}
        renderOnLogin={(result: NSARouterMakerResult) =>
        {
            let REACT_APP_BASE_URL_NWS_REGION = new EnvService("REACT_APP_BASE_URL_NWS_REGION", true).getString();

            let nws_region = new NamirasoftNWSRegionServer(REACT_APP_BASE_URL_NWS_REGION, result.account.token_manager, result.notifier.onError);

            let servers = { nws_region };

            return (
                <FieldCacheService
                    {...result}
                    render={(rows => (
                        <Routes>
                            <Route path={NWSRegionRoutes.Home} element={<HomePage {...result} />} />
                            <Route path={NWSRegionRoutes.RegionList} element={<RegionListPage {...result} servers={servers} />}></Route>
                            <Route path={NWSRegionRoutes.RegionView(":id")} element={<RegionViewPage {...result} servers={servers} />}></Route>

                            {NSFRouterMaker.getRoutes({ ...result, rows, children: <></> })}

                            <Route path="*" element={<NSNotFoundPage />} />
                        </Routes>
                    ))}
                />
            );
        }}
        renderOnLogout={() => (
            <Routes>
                <Route path={NWSRegionRoutes.Home} element={<LoginPage />} />
                <Route path="*" element={<LoginPage />} />
            </Routes>
        )}
        getNSALayout={(props) => (
            <NWSRegionLayout {...props}>
                {props.children}
            </NWSRegionLayout>
        )}
        requirement={{
            verification: {
                email: false,
                phone: false
            }
        }}
    />;
}